




































import { Component } from 'vue-mixin-decorator';

import BaseView from '@/views/BaseView.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamGuide from '@/components/ExamGuide.vue';
import ExamNav from '@/components/ExamNav.vue';
import IndicatorModal from '@/components/IndicatorModal.vue';

import RepositoryFactory from '@/repository/RepositoryFactory';

import ExamInfo from '@/models/exam/ExamInfo';
import * as CartUtil from '@/common/CartUtil';

@Component(
  {
    components: {
      'e-footer': ExamFooter,
      'e-guide': ExamGuide,
      'e-nav': ExamNav,
      'e-indicator': IndicatorModal,
    },
  },
)
export default class PurchaseResult extends BaseView {
  private examInfo: ExamInfo = new ExamInfo();

  private isIndicatorDisplay = false;

  private async created() {
    // パラメータなし・該当データ存在しない場合はTOPへ遷移
    if (!this.$route.query.cart_code) {
      this.$router.replace(this.paths.TOP);
    }
  }

  private async mounted() {
    this.initStaticScripts();

    this.isIndicatorDisplay = true;
    sessionStorage.removeItem(CartUtil.SESSION_CART_CODE_KEY);

    // 検定情報を取得する
    const ExamRepository = RepositoryFactory.get().exam;
    await ExamRepository.getExam().then((response: any) => {
      if (response.status === 200) {
        // eslint-disable-next-line prefer-destructuring
        const data = response.data;
        this.examInfo.examTitle = data.exam_title;
        this.examInfo.inPeriod = data.in_period;
      }
    });

    this.isIndicatorDisplay = false;
  }

  /**
   * 静的CssとJsの読み込み
   */
  private initStaticScripts() {
    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    const GoodsResultCss = document.createElement('link');
    GoodsResultCss.rel = 'stylesheet';
    GoodsResultCss.href = '/css/purchase/result.css';
    this.$el.appendChild(GoodsResultCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);
  }
}
